<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 d-flex pl-0 flex-column flex-md-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 mb-2 pt-3 pl-0 pr-0 d-flex flex-wrap flex-column">
                            <iframe class="embed-responsive-item rounded" height="480" :src="generateEmbed(dataDetailTutorial.tutorial_link)" allowfullscreen></iframe>
                            <div class="col-12 pl-0 pr-0 mt-2 mb-2 d-flex flex-column">
                                <div class="col-12 pl-0 pr-0 font-size-14 font-size-md-16">{{ dataDetailTutorial.tutorial_title }}</div>
                                <span class="badge badge-pill p-2 my-2"
                                    :style="{ 'width' : '250px', 'background-color': dataDetailTutorial.tutorial_category_color, 'color': fontColorbyBG(dataDetailTutorial.tutorial_category_color) ? '#FFFFFF' : '#000000' }">{{
                                    dataDetailTutorial.tutorial_category_name }}</span>
                                <p class="text-justify font-size-11">{{ dataDetailTutorial.tutorial_caption }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {}
    },
    methods: {
        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getDataTutorial({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getDataTutorial({ page: this.page, limit: this.limit })
            }
        },
        fontColorbyBG(bgColor) {
            if(bgColor){
                let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
                let r = parseInt(color.substring(0, 2), 16); // hexToR
                let g = parseInt(color.substring(2, 4), 16); // hexToG
                let b = parseInt(color.substring(4, 6), 16); // hexToB
                return ((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186;
            }
        },
        generateEmbed(url) {
            if(url){
                let video_id = url.split('v=')[1]
                let ampersandPosition = video_id.indexOf('&')
                if (ampersandPosition != -1) {
                    video_id = video_id.substring(0, ampersandPosition)
                }
                return "https://www.youtube.com/embed/" + video_id
            }
        },
        ...mapActions('tutorialList', ['getDetailTutorial']),
    },
    computed: {
        ...mapState('tutorialList', ['dataDetailTutorial']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),
    },
    async created() {
        this.$store.dispatch('setPageTitle', 'Detail E-Learning');
        await this.getDetailTutorial({
            id: this.$route.params.id
        }).catch(err => {
            this.alertMessage = err
            this.$refs.modalAlert.modalShow()
        })
    }
};
</script>